import updateDatalimits from './updateDatalimits';

const watchMultieditDatalimits = [ updateDatalimits];

export default watchMultieditDatalimits;
